import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

const BreakEvenPoint = ({ fixedCost, dateChart, data }) => {
  var xxx = 0;

  const labels = data.map((x) => x.date);

  const data1 = {
    labels: labels,
    datasets: [
      {
        label: "Sales ",
        pointStyle: "circle",
        pointRadius: 5,
        pointHoverRadius: 15,
        data: data.map((x) => {
          const total =
            Number(x.cash) +
            Number(x.cashApp) +
            Number(x.zelle) +
            Number(x.other) +
            Number(x.card);
          xxx = xxx + total;

          return xxx;
        }),
        fill: false,
        borderColor: "green",
        tension: 0.1,
      },
      {
        label: "Fixed Cost",
        pointStyle: "circle",
        pointRadius: 1,
        pointHoverRadius: 15,
        data: data.map((x) => {
          const ff = fixedCost;
          return ff;
        }),
        fill: false,
        borderColor: "red",
        tension: 0.1,
      },
    ],
  };

  var options = {
    scales: {
      y: {
        beginAtZero: true,
        display: true,
      },
      x: {
        display: false,
      },
    },
  };

  return (
    <div>
      <Grid>
        <Box>
          <Typography variant="caption">
            Break Even Point {dateChart}
          </Typography>
        </Box>
        <Box>
          <Line data={data1} options={options} />
        </Box>
      </Grid>
    </div>
  );
};

export default BreakEvenPoint;
